import apiClient from "../api";

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const listCrmClients = async (storeId, onlyDebtors = false) => {
  try {
    const response = await apiClient.get(`gestock/stores/${storeId}/crm/clients`, {
      params: { onlyDebtors },
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getManualCustomers = async (storeId) => {
  try {
    const response = await apiClient.get(`gestock/stores/${storeId}/manual-customers`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createManualCustomer = async (storeId, payload) => {
  try {
    const response = await apiClient.post(`gestock/stores/${storeId}/manual-customers`, payload, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getCampaignGroups = async (storeId) => {
  try {
    const response = await apiClient.get(`gestock/stores/${storeId}/campaign-groups`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createCampaignGroup = async (storeId, payload) => {
  try {
    const response = await apiClient.post(`gestock/stores/${storeId}/campaign-groups`, payload, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSmsCampaigns = async (storeId, page = 1, limit = 50) => {
  try {
    const response = await apiClient.get(`gestock/stores/${storeId}/campaigns/sms`, {
      params: { page, limit },
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createSmsCampaign = async (storeId, payload) => {
  try {
    const response = await apiClient.post(`gestock/stores/${storeId}/campaigns/sms`, payload, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
